import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, Modal } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

import { styled } from "@mui/material/styles";
import pauseButtonIcon from "../../../assets/loan-interactive/pause.png";
import playButtonIcon from "../../../assets/loan-interactive/play.png";
import fastForwardIcon from "../../../assets/loan-interactive/fastforward.png";
import fastForwardActiveIcon from "../../../assets/loan-interactive/fast-forward_active-button.png";
import "./CustomMessageDialog.css";
import TypeEffect from "./typingEffect";
import ProgressContext from "../../../utils/context";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
	},
}));

const alp = ["A.", "B.", "C.", "D.", "E.", "F.", "G.", "H.", "I.", "J.", "K.", "L."];
function CustomMessageDialog({ mainContainer, objData, buttonElement, pageLang }) {
	const { updateProgress } = useContext(ProgressContext);
	const [currentIndexArr, setCurrentIndexArr] = useState([0]);
	const [selectedIndexObj, setSelectedIndexObj] = useState({});
	const [shouldRender, setShouldRender] = useState(true);
	const [pauseMessage, setPauseMessage] = useState(false);
	const [fastMessage, setfastMessage] = useState(false);
	const [prevpauseMessage, setPrevpauseMessage] = useState();
	const [openModal, setOpenModal] = useState(false);
	function scrollToBottom() {
		var scrollableDiv = document.getElementById("scrollableDiv");
		scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
	}

	useEffect(() => {
		scrollToBottom();
	}, [currentIndexArr, selectedIndexObj]);

	useEffect(() => {
		if (prevpauseMessage === true && pauseMessage === false) {
			if (objData?.[currentIndexArr.length - 1]?.type === "quiz") {
				if (
					!selectedIndexObj["quiz" + [currentIndexArr.length - 1] + "Show"] ||
					selectedIndexObj["quiz" + [currentIndexArr.length - 1] + "Show"] === false
				) {
					return;
				}
			}
			nextMessage(currentIndexArr.length);
		}
	}, [pauseMessage]);

	function handlesPause() {
		setPauseMessage(!pauseMessage);
		setPrevpauseMessage(pauseMessage);
	}

	function calculatePercentage(value, total) {
		if (total === 0) {
			return 0; // To avoid division by zero
		}

		let percentagevalue = (value / total) * 100;
		if (percentagevalue > 100) {
			percentagevalue = 100;
			updateProgress(100);
		}

		return percentagevalue;
	}

	function nextMessage(newData) {
		if (pauseMessage === true) {
			return;
		}
		if (objData[newData]?.delayStartSeconds) {
			const delaySec = parseInt(objData[newData]?.delayStartSeconds + "000");
			const timeoutId = setTimeout(() => {
				setCurrentIndexArr((prev) => {
					const uniqueArray = [...prev, newData].filter((value, index, self) => {
						return self.indexOf(value) === index;
					});
					return uniqueArray;
				});
			}, delaySec);

			return () => clearTimeout(timeoutId);
		} else {
			setCurrentIndexArr((prev) => {
				const uniqueArray = [...prev, newData].filter((value, index, self) => {
					return self.indexOf(value) === index;
				});
				return uniqueArray;
			});
		}
	}

	const handleItemClick = (quizSelectedAnswerIndex, currentSelectedIndex, type) => {
		if (selectedIndexObj[type + currentSelectedIndex + "Show"] !== true) {
			setSelectedIndexObj((prev) => {
				return {
					...prev,
					[type + currentSelectedIndex]: quizSelectedAnswerIndex,
					[type + currentSelectedIndex + "Show"]: false,
				};
			});
		}
	};

	const handleDelayMessage = (delay) => {
		const delaySec = parseInt(delay + "000");

		const timeoutId = setTimeout(() => {
			setShouldRender(true);
		}, delaySec); // 500 milliseconds delay

		return () => clearTimeout(timeoutId);
	};

	return (
		<>
			<Box
				id="scrollableDiv"
				container
				className="customMessageContainer"
				sx={{
					width: "100%",
					height: "800px",
					...mainContainer,
				}}>
				<Grid container direction="column">
					{currentIndexArr.map((currentIndex) => {
						return (
							<>
								{shouldRender && objData?.[currentIndex] && (
									<>
										{objData?.[currentIndex]?.type === "message" && (
											<>
												{objData?.[currentIndex]?.person === "left" && (
													<div style={{ width: "100%" }}>
														<div
															style={{
																marginBottom: ".5rem",
																float: "left",
																backgroundColor: "#1cc4ec",
																padding: "1rem",
																borderRadius: "1rem",
																color: "white",
																width: "70%",
																wordWrap: "break-word",
															}}>
															<b>
																<TypeEffect
																	text={objData?.[currentIndex]?.zMessage}
																	delay={fastMessage ? 2 : objData?.[currentIndex]?.secondsPerWord}
																	callbackFunction={() => nextMessage(currentIndex + 1)}
																	scrollDown={() => scrollToBottom()}
																/>
															</b>
														</div>
													</div>
												)}
												{objData?.[currentIndex]?.person === "right" && (
													<div style={{ width: "100%" }}>
														<div
															style={{
																marginBottom: ".5rem",
																float: "right",
																backgroundColor: "white",
																padding: "1rem",
																borderRadius: "1rem",
																color: "black",
																width: "70%",
																wordWrap: "break-word",
															}}>
															<b>
																<TypeEffect
																	text={objData?.[currentIndex]?.zMessage}
																	delay={fastMessage ? 2 : objData?.[currentIndex]?.secondsPerWord}
																	callbackFunction={() => nextMessage(currentIndex + 1)}
																	scrollDown={() => scrollToBottom()}
																/>
															</b>
														</div>
													</div>
												)}
											</>
										)}
										{/* quiz questions */}
										{objData?.[currentIndex]?.type === "quiz" && (
											<>
												<Grid item xs={12}>
													<div
														style={{
															marginBottom: ".5rem",
															float: objData?.[currentIndex]?.person,
															backgroundColor:
																objData?.[currentIndex]?.person === "left" ? "#1cc4ec" : "white",
															padding: "1rem",
															borderRadius: "1rem",
															color: objData?.[currentIndex]?.person === "left" ? "black" : "white",
														}}>
														<p
															style={{
																paddingBottom: "2rem",
																color:
																	objData?.[currentIndex]?.person === "left" ? "white" : "black",
															}}>
															<b>
																{pageLang === "ph" ? "Pumili ng Sagot" : "Select an option below:"}
															</b>
														</p>
														{objData?.[currentIndex]?.zOptions.length === 2 ? (
															<>
																{" "}
																<Grid container>
																	{objData?.[currentIndex]?.zOptions?.map((zoption, index) => {
																		const isSelected =
																			index === selectedIndexObj["quiz" + currentIndex];

																		return (
																			<Grid item xs={6}>
																				<div
																					key={index}
																					style={{
																						border: isSelected ? "solid #019b48 2px" : null,
																						cursor: "pointer",
																						backgroundColor: isSelected ? "#60ff95" : "white",
																						padding: ".1rem",
																						margin: ".5rem",
																						borderRadius: ".5rem",
																						wordWrap: "break-word",
																						fontSize: ".8rem",
																					}}
																					onClick={() =>
																						handleItemClick(index, currentIndex, "quiz")
																					}>
																					<div
																						style={{
																							padding: ".5rem",
																							margin: ".1rem",
																							borderRadius: ".5rem",
																							color: "black",
																						}}>
																						<Grid container>
																							<Grid item xs={12}>
																								{zoption?.image && (
																									<img
																										src={zoption?.image}
																										alt="Image Display"
																										style={{
																											paddingBottom: ".5rem",
																											maxWidth: "300px",
																											maxHeight: "250px",
																										}}
																									/>
																								)}
																							</Grid>
																							<Grid item xs={12}>
																								{<b>{alp[index] + " " + zoption?.text}</b>}
																							</Grid>
																						</Grid>
																					</div>
																				</div>
																			</Grid>
																		);
																	})}
																</Grid>
															</>
														) : (
															<>
																{objData?.[currentIndex]?.zOptions?.map((zoption, index) => {
																	const isSelected =
																		index === selectedIndexObj["quiz" + currentIndex];

																	return (
																		<div
																			key={index}
																			style={{
																				border: isSelected ? "solid #019b48 2px" : null,
																				cursor: "pointer",
																				backgroundColor: isSelected ? "#60ff95" : "white",
																				padding: ".1rem",
																				margin: ".5rem",
																				borderRadius: ".5rem",
																				wordWrap: "break-word",
																				fontSize: ".8rem",
																			}}
																			onClick={() => handleItemClick(index, currentIndex, "quiz")}>
																			<div
																				style={{
																					padding: ".5rem",
																					margin: ".1rem",
																					borderRadius: ".5rem",
																					color: "black",
																				}}>
																				<Grid container>
																					<Grid item xs={12} sx={{ paddingLeft: "25%" }}>
																						{zoption?.image && (
																							<img
																								src={zoption?.image}
																								alt="Image Display"
																								style={{
																									paddingBottom: "1rem",
																									maxWidth: "300px",
																									maxHeight: "250px",
																								}}
																							/>
																						)}
																					</Grid>
																					<Grid item xs={12}>
																						{<b>{alp[index] + " " + zoption?.text}</b>}
																					</Grid>
																				</Grid>
																			</div>
																		</div>
																	);
																})}
															</>
														)}

														<p
															onClick={() => {
																selectedIndexObj["quiz" + currentIndex + "Show"] === false
																	? setSelectedIndexObj((prev) => {
																			return {
																				...prev,
																				["quiz" + currentIndex + "Show"]: true,
																			};
																	  })
																	: setOpenModal(true);
															}}
															style={{
																paddingTop: "2rem",
																float:
																	objData?.[currentIndex]?.person === "left" ? "right" : "left",
																cursor: "pointer",
																color:
																	objData?.[currentIndex]?.person === "left" ? "white" : "black",
															}}>
															<b>
																{objData?.[currentIndex]?.person === "right" && (
																	<ArrowBackRoundedIcon
																		sx={{
																			width: "35px",
																			height: "35px",
																			marginBottom: "-.75rem",
																		}}
																	/>
																)}
																{pageLang === "ph" ? "I-reply ang Sagot" : "Click to Reply"}
																{objData?.[currentIndex]?.person === "left" && (
																	<ArrowForwardRoundedIcon
																		sx={{
																			width: "35px",
																			height: "35px",
																			marginBottom: "-.75rem",
																		}}
																	/>
																)}
															</b>
														</p>
													</div>
												</Grid>
											</>
										)}
										{/* response */}
										{objData?.[currentIndex]?.type === "quiz" && (
											<>
												{objData?.[currentIndex]?.zResponses?.map((zResponse, index) => {
													const isSelected = index === selectedIndexObj["quiz" + currentIndex];

													return (
														<>
															{isSelected &&
																selectedIndexObj["quiz" + currentIndex + "Show"] === true && (
																	<Grid item xs={12}>
																		<div
																			onLoad={() => scrollToBottom()}
																			style={{
																				marginBottom: ".5rem",
																				float:
																					objData?.[currentIndex]?.person === "left"
																						? "right"
																						: "left",
																				backgroundColor:
																					objData?.[currentIndex]?.person === "left"
																						? "white"
																						: "#1cc4ec",
																				padding: "1rem",
																				borderRadius: "1rem",

																				width: "70%",
																				color:
																					objData?.[currentIndex]?.person === "left"
																						? "black"
																						: "white",
																			}}>
																			<div
																				style={{
																					margin: ".1rem",
																					borderRadius: ".5rem",
																					color:
																						objData?.[currentIndex]?.person === "left"
																							? "black"
																							: "white",
																					wordWrap: "break-word",
																				}}>
																				<b>
																					<TypeEffect
																						text={zResponse}
																						delay={
																							fastMessage
																								? 2
																								: objData?.[currentIndex]?.secondsPerWord
																						}
																						callbackFunction={() => nextMessage(currentIndex + 1)}
																						scrollDown={() => scrollToBottom()}
																					/>
																				</b>
																			</div>
																		</div>
																	</Grid>
																)}
														</>
													);
												})}
											</>
										)}
									</>
								)}
							</>
						);
					})}
					{calculatePercentage(currentIndexArr?.length, objData?.length) === 100 && (
						<div style={{ float: "right" }}>{buttonElement}</div>
					)}
				</Grid>
			</Box>
			<div style={{ display: "flex", marginTop: "1rem" }}>
				<div style={{ flexGrow: "1", marginTop: ".5rem" }}>
					{" "}
					<BorderLinearProgress
						variant="determinate"
						value={calculatePercentage(currentIndexArr?.length, objData?.length)}
					/>
				</div>
				<div
					style={{ cursor: "pointer", paddingLeft: "1rem" }}
					onClick={() => {
						setfastMessage(!fastMessage);
					}}>
					{" "}
					<img style={{}} src={fastMessage ? fastForwardActiveIcon : fastForwardIcon} />
				</div>
				<div
					style={{ cursor: "pointer", paddingLeft: "1rem" }}
					onClick={() => {
						handlesPause();
					}}>
					{" "}
					<img src={pauseMessage ? playButtonIcon : pauseButtonIcon} />
				</div>
			</div>

			<Dialog
				sx={{ "& .MuiPaper-root": { borderRadius: "1rem" } }}
				open={openModal}
				onClose={() => setOpenModal(false)}>
				<DialogTitle style={{ marginTop: "1.5rem", borderRadius: "1rem" }}>
					{pageLang === "ph" ? "Pumili muna ng sagot" : "Select an answer first!"}
				</DialogTitle>

				<DialogActions>
					<Button onClick={() => setOpenModal(false)}>OK!</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

export default CustomMessageDialog;
